module.exports = __webpack_public_path__ + "static/source-sans-3-regular.25758bda.woff2";